<template>
  <div class="font-size-xs">
    <a :href="NRS_GO_TERMS" target="_blank" rel="noreferrer">
      <span class="color-suva-grey">Terms and Conditions</span>
    </a>
    |
    <a :href="NRS_PLUS_PRIVACY_POLICY" target="_blank" rel="noreferrer">
      <span class="color-suva-grey">Privacy Policy</span>
    </a>
    <span class="d-none d-sm-inline">{{ " | " }}</span>
    <div v-if="!canada" class="d-sm-inline-block text-center text-sm-left">
      <a :href="IDT_CCPA" target="_blank" rel="noreferrer">
        <span class="color-suva-grey">California Consumer Privacy Notice</span>
      </a>
    </div>
    <a
      v-if="!canada"
      class="d-block"
      :href="IDT_VDCPA"
      target="_blank"
      rel="noreferrer"
    >
      <span class="color-suva-grey">Virginia Privacy Notice</span>
    </a>
  </div>
</template>

<script>
import urls from "@/urls.json";
import { mapGetters } from "vuex";

export default {
  name: "LegalLinks",
  computed: {
    ...mapGetters("store", {
      canada: "canada",
    }),
  },
  created() {
    this.NRS_GO_TERMS = urls.NRS_GO_TERMS;
    this.NRS_PLUS_PRIVACY_POLICY = this.canada
      ? urls.NRS_PLUS_PRIVACY_POLICY_CANADA
      : urls.NRS_PLUS_PRIVACY_POLICY;
    this.IDT_CCPA = urls.IDT_CCPA;
    this.IDT_VDCPA = urls.IDT_VDCPA;
  },
  props: {
    closeAuth: Function,
  },
};
</script>
